import React from "react";
import styles from "./MPill.module.css";

interface MPillProps {
  icon: React.ReactNode;
  children: React.ReactNode;
  variant?: "default" | "filled" | "banner";
  count?: number | string;
  className?: string;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  uncategorized?: boolean;
  bannerText?: React.ReactNode;
}

/**
 * MPill: A pill-shaped UI component for displaying an icon and label.
 * Default and filled states supported via className/variant.
 * Banner variant shows a styled text label on the right instead of a numeric count.
 */
const MPill: React.FC<MPillProps> = ({
  icon,
  children,
  variant = "default",
  count,
  className,
  onClick,
  uncategorized,
  bannerText,
}) => {
  const pillClass = [
    styles.mpill,
    variant === "filled" ? styles.filled : "",
    uncategorized ? styles.uncategorizedPill : "",
    className || "",
    onClick ? styles.clickable : "",
  ]
    .filter(Boolean)
    .join(" ");
  return (
    <div
      className={pillClass}
      onClick={onClick}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyPress={
        onClick
          ? (e) => {
              if (e.key === "Enter" || e.key === " ") onClick(e as any);
            }
          : undefined
      }
    >
      <span className={styles.icon}>{icon}</span>
      <span className={styles.text}>{children}</span>
      {variant === "banner" && bannerText && (
        <span className={styles.bannerText}>{bannerText}</span>
      )}
      {variant !== "banner" && count !== undefined && (
        <span className={styles.count}>{count}</span>
      )}
    </div>
  );
};

export default MPill;
